// Avisos de Anúncios Meta no sino do painel: anúncio aprovado ou reprovado,
// campanha renovada, campanha que chegou ao fim.
//
// Um único polling por aba, compartilhado por quem assinar (sino do computador
// e menu do celular). A loja que não usa Anúncios Meta faz UMA leitura e para:
// o servidor responde `acompanhar: false`.
import { anunciosMetaApi } from "../api";

const INTERVALO_MS = 120000;
const VAZIO = { avisos: [], naoLidos: 0 };

let estado = VAZIO;
let timer = null;
const ouvintes = new Set();

function publicar(novo) {
  estado = novo;
  ouvintes.forEach((avisar) => avisar());
}

function parar() {
  if (timer) { clearInterval(timer); timer = null; }
}

async function buscar() {
  try {
    const dados = await anunciosMetaApi.avisos();
    publicar({ avisos: dados.avisos || [], naoLidos: dados.nao_lidos || 0 });
    if (dados.acompanhar === false) parar();
  } catch (_) {
    // Falha de rede não apaga o que já estava no sino.
  }
}

export function assinarAvisosMeta(avisar) {
  ouvintes.add(avisar);
  if (!timer) {
    buscar();
    timer = setInterval(buscar, INTERVALO_MS);
  }
  return () => {
    ouvintes.delete(avisar);
    if (ouvintes.size === 0) parar();
  };
}

export const lerAvisosMeta = () => estado;
export const lerAvisosMetaVazio = () => VAZIO;

/** A tela de Anúncios Meta chama depois de publicar ou mudar uma campanha: o sino atualiza na hora. */
export function atualizarAvisosMeta() {
  if (!timer && ouvintes.size > 0) timer = setInterval(buscar, INTERVALO_MS);   // tinha parado: a loja não tinha nada a acompanhar
  return buscar();
}

export async function marcarAvisosMetaLidos() {
  await anunciosMetaApi.marcarAvisosLidos();
  const agora = new Date().toISOString();
  publicar({ avisos: estado.avisos.map((a) => (a.lido_em ? a : { ...a, lido_em: agora })), naoLidos: 0 });
}
